import { AdminPage } from "@/pages/AdminPage.tsx";
import { BoothPage } from "@/pages/BoothPage.tsx";
import { ListenerPage } from "@/pages/ListenerPage.tsx";

export function App() {
  const path = window.location.pathname;
  if (/^\/admin\/?$/.test(path)) return <AdminPage />;
  const match = /^\/listen\/([A-Za-z0-9]{4,16})\/?$/.exec(path);
  return match ? <ListenerPage code={match[1]!.toUpperCase()} /> : <BoothPage />;
}
